/* eslint-disable */
import { uniqueId } from "lodash";
import { IconPoint, IconNotes, IconUserCircle, IconTicket } from "@tabler/icons-react";
import { Dashboard, DeviceHub, Insights, ListAlt } from "@mui/icons-material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { OneDotSvg } from "../../../common/utils";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import HubIcon from "@mui/icons-material/Hub";

export const MenuitemsUser = [
  // {
  //   id: uniqueId(),
  //   title: "Projects",
  //   icon: AccountTreeIcon,
  //   href: "/projects",
  //   children: [
  //     {
  //       id: uniqueId(),
  //       title: "Discover",
  //       icon: IconPoint,
  //       href: "/",
  //       children: [
  //         {
  //           id: uniqueId(),
  //           title: "Overview",
  //           icon: OneDotSvg,
  //           href: "/",
  //         },
  //         {
  //           id: uniqueId(),
  //           title: "Site audit",
  //           icon: OneDotSvg,
  //           href: `/`,
  //         },
  //         {
  //           id: uniqueId(),
  //           title: "Desktop performance",
  //           icon: OneDotSvg,
  //           href: `/report/desktop`,
  //         },
  //         {
  //           id: uniqueId(),
  //           title: "Uptime monitoring",
  //           icon: OneDotSvg,
  //           href: "/uptime-monitoring",
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    navlabel: true,
    subheader: "Explore",
  },

  {
    id: uniqueId(),
    title: "Dashboard",
    icon: Dashboard,
    href: "/dashboard?menu=dashboard",
    childPaths: ["/dashboard"],
  },
  // {
  //   id: uniqueId(),
  //   title: "Organisation",
  //   icon: DeviceHub,
  //   href: "/organisationsdashboard",
  // },
  {
    id: uniqueId(),
    title: "WebSite list",
    icon: ListAlt,
    href: "/websitelist",
    childPaths: ["/websitelist", "/projects/", "/project-config", "/project-detail/", "/project-inner-detail/"],
  },
  {
    id: uniqueId(),
    title: "Website analyzing",
    icon: Insights,
    href: "/website",
  },
  {
    id: uniqueId(),
    title: "Account settings",
    icon: IconUserCircle,
    href: "/account-settings",
  },
  {
    id: uniqueId(),
    title: "Notes",
    icon: IconNotes,
    href: "/notes",
  },
  {
    id: uniqueId(),
    title: "App integration",
    icon: IntegrationInstructionsIcon,
    href: "/app-integration",
  },
  {
    id: uniqueId(),
    title: "Content Calendar",
    icon: CalendarMonthIcon,
    href: "/content-calendar",
  },

  {
    navlabel: true,
    subheader: "AI Tools",
  },
  {
    id: uniqueId(),
    title: "AI Content & SEO Hub",
    icon: HubIcon,
    href: "/ai-blog-generator",
    childPaths: [
      "/ai-blog-generator", "/ai-blog-writer", "/content-score", "/content-edit",
      "/blog-titles", "/blog-paragraphs", "/blog-headings", "/edit-blog",
      "/keywordsDashboard", "/urlKeywords", "/generated-blogs",
      "/keyword-reserch", "/keyword-ranking",
    ],
  },
  {
    id: uniqueId(),
    title: "Content Strategy",
    icon: AutoFixHighIcon,
    href: "/ai-content-strategy",
  },
  {
    id: uniqueId(),
    title: "SEO Autopilot",
    icon: SmartToyIcon,
    href: "/ai-autopilot",
  },
  {
    id: uniqueId(),
    title: "A/B Testing",
    icon: CompareArrowsIcon,
    href: "/ai-ab-testing",
  },
];

export const MenuitemsAdmin = [
  {
    id: uniqueId(),
    title: "Projects",
    icon: AccountTreeIcon,
    href: "/",
    children: [
      {
        id: uniqueId(),
        title: "Discover",
        icon: IconPoint,
        href: "/",
        children: [
          {
            id: uniqueId(),
            title: "Overview",
            icon: OneDotSvg,
            href: "/",
          },
          {
            id: uniqueId(),
            title: "Site audit",
            icon: OneDotSvg,
            href: `/`,
          },
          {
            id: uniqueId(),
            title: "Desktop performance",
            icon: OneDotSvg,
            href: `/report/desktop`,
          },
          {
            id: uniqueId(),
            title: "Uptime monitoring",
            icon: OneDotSvg,
            href: "/uptime-monitoring",
          },
        ],
      },
    ],
  },

  {
    navlabel: true,
    subheader: "Explore",
  },

  {
    id: uniqueId(),
    title: "Dashboard",
    icon: Dashboard,
    href: "/dashboard?menu=dashboard",
    childPaths: ["/dashboard"],
  },
  {
    id: uniqueId(),
    title: "WebSite list",
    icon: ListAlt,
    href: "/websitelist",
    childPaths: ["/websitelist", "/projects/", "/project-config", "/project-detail/", "/project-inner-detail/"],
  },
  {
    id: uniqueId(),
    title: "Website analyzing",
    icon: Insights,
    href: "/website",
  },
  {
    id: uniqueId(),
    title: "Account settings",
    icon: IconUserCircle,
    href: "/account-settings",
  },
  {
    id: uniqueId(),
    title: "Notes",
    icon: IconNotes,
    href: "/notes",
  },
  {
    id: uniqueId(),
    title: "App integration",
    icon: IntegrationInstructionsIcon,
    href: "/app-integration",
  },
];
